module.exports = __webpack_public_path__ + "img/logo.d8fee51d.png";